export default __webpack_public_path__ + "static/paleto_bay_counterfeit-7d412f6560d4548098632963697fbe49.png";